import usePriceAndPlanStore from '@aibees/shared/features/price-and-plan/store';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Stack, Typography } from '@mui/material';
import { memo, MouseEventHandler } from 'react';
import { ChangeDuration } from '../change-duration';
import { CurrentPlanAlert } from '../current-plan-alert';
import { PricingCards } from '../pricing-cards';
import * as Styled from './styles';
import * as SX from './sx';
import type { PricingHeaderProps as Props } from './types';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@aibees/shared/components';

export const PricingHeader = memo(({ className }: Props) => {
  const yearly = usePriceAndPlanStore((s) => s.yearly);
  const navigate = useNavigate();

  const handleBack: MouseEventHandler<HTMLButtonElement> = () => {
    navigate(-1);
  };

  return (
    <Styled.Wrapper
      className={classnames('PricingHeader', className)}
      sx={SX.root}
    >
      <Stack sx={SX.box}>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          gap={4}
        >
          <Stack
            justifyContent="space-between"
            alignItems="center"
            gap={1.25}
            width="100%"
          >
            <Typography variant="h3" fontWeight={700} color="grey.700">
              Plan & Pricing
            </Typography>
            <Typography variant="body3" fontWeight={400} color="grey.700">
              Flexible plans designed for teams of all sizes. Simple,
              transparent pricing to help you grow.{' '}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Button
              size="small"
              variant="soft"
              startIcon={<Icon name="arrow-left-fill" size={16} />}
              onClick={handleBack}
            >
              Back
            </Button>
            <ChangeDuration />
            <Box />
          </Stack>
        </Stack>
        <CurrentPlanAlert />
        <PricingCards yearly={yearly} />
      </Stack>
    </Styled.Wrapper>
  );
});

PricingHeader.displayName = 'PricingHeader';
